export const scrollToContact = () => {
  document
    .getElementById("contact-us")
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const openClientPortal = () => {
  const portalUrl = process.env.REACT_APP_CLIENT_PORTAL_URL;

  if (!portalUrl) {
    console.warn("REACT_APP_CLIENT_PORTAL_URL has not been configured.");
    return;
  }

  window.open(portalUrl, "_blank", "noopener,noreferrer");
};
